module.exports = __webpack_public_path__ + "img/街舞.9978c358.gif";